<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/quotes">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex" v-if="isLoaded">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Редактирование цитаты</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Заголовок" name="title"></new-input>
                  <calendar name="created_at" title="Дата создания"></calendar>
                  <new-input title="Ссылка" name="url"></new-input>
                  <edit-drop-down field-name="title" title="Автор" :id="parentId.authors" :url="apiUrls.content"
                                  name="author_id"></edit-drop-down>
                  <new-input title="Alt" name="alt"></new-input>
                  <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                             name="img"></edit-file>
                  <div class="list">
                    <p>Настройки отображения</p>
                    <div class="checkbox-group">
                      <checkbox name="show_author" title="Отображать автора"></checkbox>
                      <checkbox name="show_date" title="Отображать дату"></checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="folder radius" v-if="isLoaded">
              <div class="column caption">
                <p>СЕО настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Название страницы" name="seo_title"></new-input>
                  <new-text-area title="Описание" name="seo_desc"></new-text-area>
                  <new-text-area title="Ключевые слова" name="seo_key"></new-text-area>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="folder radius">
          <div class="column caption">
            <p>Текст цитаты</p>
          </div>
          <div class="column" :class="{saved: savedFields.hasOwnProperty('text') && !changedText}">
            <textarea id="editor" name="editor" v-model="text"></textarea>
            <add-image v-if="isLoaded"/>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import Checkbox from '@/components/edit-form/Checkbox'
  import {createNamespacedHelpers} from 'vuex'
  import AddImage from '@/components/edit-form/AddImage'
  import Calendar from '../../../edit-form/Calendar'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data () {
      return {
        isLoaded: false,
        editorInstance: '',
        text: '',
        changedText: false,
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent',
        'savedFields'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset',
        'updateNews'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField',
        'setEditorInstance'
      ]),
      onSubmit () {
        this.setItemField({fieldName: 'text', value: this.text})
        let object = {
          alt: this.item.alt
        }
        this.edit({
          title: this.item.title,
          object: JSON.stringify(object),
          created_at: this.item.created_at,
          url: this.item.url,
          seo_title: this.item.seo_title,
          show_author: this.item.show_author,
          text: this.editor.getData(),
          show_date: this.item.show_date,
          seo_desc: this.item.seo_desc,
          seo_key: this.item.seo_key,
          img: this.item.img,
          author_id: this.item.author_id
        })
          .then(data => {
            this.updateNews({
              title: data.article.title,
              id: data.article.id,
              newsId: data.lastNews.id,
              section_id: this.parentId.quotes,
              is_active: this.item.is_active,
              url: {
                categoryId: null,
                articleUrl: data.article.url
              },
              img: data.article.img,
              subtext: data.article.seo_desc
            })
          })
      }
    },
    created () {
      this.resetModule()
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Цитаты',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование цитаты',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите заголовок цитаты', hasError: false},
          created_at: {message: 'Введите дату создания', hasError: false, isNullable: true},
          url: {message: 'Введите ссылку', hasError: false},
          author_id: {isNullable: true, hasError: false},
          show_author: {hasError: false, isNullable: true},
          text: {hasError: false, isNullable: true},
          show_date: {hasError: false, isNullable: true},
          alt: {message: 'Введите краткое описание картинки', hasError: false},
          seo_title: {message: 'Введите название страницы', isNullable: true, hasError: false},
          seo_desc: {message: 'Напишите краткое описание', isNullable: true, hasError: false},
          seo_key: {message: 'Напишите ключевые слова', isNullable: true, hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false}
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then((response) => {
        this.text = response.text
        this.editor = CKEDITOR.replace('editor')
        this.editor.on('change', () => {
          this.changedText = true
        })
        this.setEditorInstance(this.editor)
        for (let key in response.object) {
          if (response.object.hasOwnProperty(key)) {
            this.setItemField({fieldName: key, value: response.object[key]})
          }
        }
        this.isLoaded = true
      })
    },
    components: {
      Calendar,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      Checkbox,
      AddImage
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/quotes/pages/Edit.vue